import i18n from '@/plugins/vue-i18n';
// TODO: aov3-8283 fix circular dependency issue
// eslint-disable-next-line import/no-cycle
import { useScenariosStore } from '@/stores/scenarios';
import { useSnackbarStore } from '@/stores/snackbar';
import to from 'await-to-js';
import axios from 'axios';
import { findIndex, map } from 'lodash';
import { defineStore } from 'pinia';
import { computed, ref, shallowRef } from 'vue';

export const useSimpleSwapRunsStore = defineStore('simpleSwapRuns', () => {
  const scenariosStore = useScenariosStore();
  const snackbarStore = useSnackbarStore();

  // State
  const scenarioSimpleSwapRuns = ref([]);
  const loading = shallowRef(false);

  // Getters
  const getSimpleSwapRunDescriptions = computed(() => {
    return map(scenarioSimpleSwapRuns.value, sr => sr.runDescription);
  });

  // Helpers (previouse mutations)
  function updateSimpleSwapRun(updatedRun) {
    const targetIx = findIndex(scenarioSimpleSwapRuns.value, run => run._id === updatedRun._id);
    scenarioSimpleSwapRuns.value[targetIx] = updatedRun;
  }
  // Actions
  async function fetchSimpleSwapRuns() {
    const scenarioId = scenariosStore.selectedScenario._id;
    loading.value = true;
    const [err, response] = await to(axios.get(`/api/scenarios/${scenarioId}/simple-swap-runs`));
    loading.value = false;
    if (err) throw new Error(err.message);
    scenarioSimpleSwapRuns.value = response.data;
  }

  async function fetchSimpleSwapRun({ _id }) {
    const [err, response] = await to(
      axios.get(`/api/scenarios/${scenariosStore.selectedScenario._id}/simple-swap-runs/${_id}`)
    );
    if (err) throw new Error(err.message);
    return response.data;
  }

  async function addSimpleSwapRun(payload) {
    const { scenarioId } = payload;
    loading.value = true;
    const [err, response] = await to(
      axios.post(`/api/scenarios/${scenarioId}/simple-swap-runs`, payload)
    );
    if (err) throw new Error(err.message);
    snackbarStore.showSuccess(i18n.t('actions.saveSuccess'));

    scenarioSimpleSwapRuns.value.push(response.data);
    loading.value = false;
  }

  async function afterSimpleSwapsComplete({ message }) {
    const updatedRun = await fetchSimpleSwapRun({ _id: message.jobArgs.simple_swaps_run_id });
    updateSimpleSwapRun(updatedRun);

    const content = i18n.t('notifications.simpleSwaps.finished', {
      name: updatedRun.runDescription,
    });
    snackbarStore.showSuccess(content);
  }

  async function afterSimpleSwapsFailed({ message }) {
    const updatedRun = fetchSimpleSwapRun({ _id: message.jobArgs.simple_swaps_run_id });
    updateSimpleSwapRun(updatedRun);

    const content = i18n.t('notifications.simpleSwaps.failed', { name: updatedRun.runDescription });
    snackbarStore.showError(content);
  }

  return {
    // states
    scenarioSimpleSwapRuns,
    loading,
    // Getters
    getSimpleSwapRunDescriptions,
    // Actions
    fetchSimpleSwapRuns,
    fetchSimpleSwapRun,
    addSimpleSwapRun,
    afterSimpleSwapsComplete,
    afterSimpleSwapsFailed,
  };
});
